export const CITY_PROPERTY_CODE = {
  blumenau: 'cadastro',
  imbituba: 'codigo_imovel',
};

// TODO: para outras cidades vai precisar configurar isso
export const VALUATION_INFO_KEY = {
  blumenau: 'inscricao_geo',
};

export const IMOBILIARIO_KEY = {
  riobranco: 'legado_imobiliario',
  criciuma: 'imoveis',
  alexania: 'edificacao' // está avaliando normalmente
};

export const IMOBILIARIO_KEY_SEARCH = {
  riobranco: 'legado_imobiliario',
  criciuma: 'imoveis',
  alexania: 'imobiliario',

};

export const LOTE_KEY = {
  riobranco: 'legado_lote',
};
